export const userEndpoints = {
  getUser: '/api/users/me/avatar',
};
